import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {

  private _invoiceapiUrl = `${environment.travel}/invoices`

  constructor(
    private _http: HttpClient
  ) { }

  getAllInvoice(pageNumber: any, pageSize:any, token: any, searchValue:any, filters: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._invoiceapiUrl}`, paginationSettings);
  }

  getAllInvoiceForLead(leadId:any, pageNumber: any, pageSize:any, token: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 10
    }
    return this._http.post<any>(`${this._invoiceapiUrl}/${leadId}`, paginationSettings);
  }

  createInvoice(formData:any):Observable<any>{
    return this._http.post<any>(`${this._invoiceapiUrl}/addinvoice`, formData);
  }

  getInvoiceDetails(id:any):Observable<any>{
    return this._http.get<any>(`${this._invoiceapiUrl}/invoice/${id}`);
  }

  deleteInvoice(invoiceId:any):Observable<any>{
    return this._http.delete<any>(`${this._invoiceapiUrl}/invoice/${invoiceId}`);
  }

  updateInvoice(invoiceId:any, formData:any):Observable<any>{
    return this._http.put<any>(`${this._invoiceapiUrl}/invoice/${invoiceId}`, formData);
  }

  getInvoiceAsTemplateHtml(invoiceId:any, showServiceAmount: any = true):Observable<any>{
    return this._http.get<any>(`${this._invoiceapiUrl}/${invoiceId}?showServiceAmount=${showServiceAmount}`, { responseType: 'text' as 'json' });
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.travel}/updateinvoices`, req)
  }

  // Vendor invoice and payments
  getAllVendorInvoice(pageNumber: any, pageSize:any, token: any, searchValue:any, filters: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${environment.travel}/GetVendorInvoices`, paginationSettings);
  }

  getAllVendorInvoiceForLead(leadId:any, pageNumber: any, pageSize:any, token: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 10
    }
    return this._http.post<any>(`${environment.travel}/GetVendorInvoicesForLead/${leadId}`, paginationSettings);
  }

  addUpdateVendorInvoice(formData:any):Observable<any>{
    return this._http.put<any>(`${environment.travel}/AddOrUpdateVendorInvoice`, formData);
  }

  getVendorInvoiceDetails(invoiceId:any):Observable<any>{
    return this._http.get<any>(`${environment.travel}/GetVendorInvoice/${invoiceId}`);
  }

  deleteVendorInvoice(invoiceId:any):Observable<any>{
    return this._http.delete<any>(`${environment.travel}/DeleteVendorInvoice/${invoiceId}`);
  }

  getAllVendorInvoiceForVendor(vendorId:any, pageNumber: any, pageSize:any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize|| 10
    }
    return this._http.post<any>(`${environment.travel}/GetVendorInvoicesByVendorId/${vendorId}`, paginationSettings);
  }

//get invoices for the Clientview 

getAllInvoiceForClient(clientId:any, pageNumber:any, pageSize:any, token:any): Observable<any> {
  const paginationSettings = {
    pageNumber: pageNumber || 1,
    pageSize: pageSize || 10
  }
  return this._http.post<any>(
    `${environment.travel}/clientinvoices/${clientId}`,
    paginationSettings
  );
}
}
